// CLASSES
import AppConfig from "@classes/AppConfig";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (fields.advice_customer_investment.length === 0) {
		return false;
	}

	if (fields.customer_amount_investment.length === 0) {
		return false;
	}

	if (fields.advice_customer_investment_motivation.length === 0) {
		return false;
	}

	if (fields.allocation_fee.length === 0) {
		return false;
	}

	if (!optionsListValueSelected(fields.checkbox_advice_suitability_knowledge_inv) ||
		fields.checkbox_advice_suitability_knowledge_inv.options[0].checked) {
		return false;
	}

	if (!optionsListValueSelected(fields.checkbox_advice_suitability_non_personal) ||
		fields.checkbox_advice_suitability_non_personal.options[0].checked) {
		return false;
	}

	if (!optionsListValueSelected(fields.checkbox_advice_risc) ||
		fields.checkbox_advice_risc.options[0].checked) {
		return false;
	}

	if (!optionsListValueSelected(fields.checkbox_advice_inv_loan)) {
		return false;
	}

	if (!optionsListValueSelected(fields.checkbox_avradan)) {
		return false;
	}

	if (fields.checkbox_avradan.options[1].checked &&
		fields.advice_customer_adv_against_motivation.length === 0) {
		return false;
	}

	return true;
}

function optionsListValueSelected(optionsList) {
	const options = optionsList.options;
	for (let i = 0; i < options.length; i++) {
		if (options[i].checked) {
			return true;
		}
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Advice/Advice.fulfillment.js